import { getSchoolPublicProfile } from '@/services/SchoolProfileService.js';

export default {
  async fetchSchoolPublicProfile(context, schoolId) {
    context.commit('setLoading', true);
    context.commit('setError', null);
    try {
      const data = await getSchoolPublicProfile(schoolId);
      context.commit('setProfile', data.data);
      return data.data;
    } catch (err) {
      context.commit('setError', err);
      throw err;
    } finally {
      context.commit('setLoading', false);
    }
  },
};
